module.exports = __webpack_public_path__ + "img/kn05_samurai02skin_shop.f0bc9a4a.png";